<template>
  <div>
    <div class="no-users" v-if="data.length === 0">
      <h3 class="no-users-text">
        No Hay Usuarios Registrados que haya registrado comentarios.
      </h3>
    </div>
    <table v-else class="table">
      <thead class="head">
        <slot name="columns">
          <th class="head-text" v-for="column in columns" :key="column">
            <div class="some">
              {{ column }}
            </div>
          </th>
          <!-- <th></th> -->
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td class="text-ne">
            {{ item.email }}
          </td>
          <td class="text-ne">
            {{ item.comentario }}
          </td>
          <slot name="adminActions" :item="item"> </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "paper-table",
  props: ["columns", "data"],
  data() {
    return {
      routeServiceId: this.$route.params.idServicio,
      perfil: "",
      adminName: process.env.VUE_APP_USER_ADMIN,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
  }
};
</script>

<style>
.head {
  background: #e0e0e0;
}
.head-text {
  color: #052333;
  height: 40px;
}
.some {
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-users {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  background: #efefef;
}

.no-users-text {
  font-weight: bold;
}

.table {
  --bs-table-striped-bg: #c8f1ea !important;
}
.table > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}

.text-ne {
  font-weight: bold;
  text-decoration: underline;
  font-size: 0.9rem !important;
}

.run {
  font-weight: bold;
  color: #24c6ab !important;
  font-size: 1rem !important;
}

.text-paam {
  font-weight: 200;
  font-size: 0.9rem !important;
  max-width: 20vw;
}

th {
  font-size: 20px;
  text-align: center !important;
}

tr {
  text-align: center !important;
}

td {
  color: #052333 !important;
}

tbody {
  background: #f5f5f5;
}

tr:hover {
  background: rgba(0, 255, 247, 0.2);
}

@media screen and (max-width: 674px) {
  th {
    font-size: 14px !important;
    text-align: initial !important;
  }
  td {
    font-size: 11px !important;
    text-align: initial !important;
  }
  table {
    width: 80%;
  }
}

@media screen and (max-width: 500px) {
  th {
    font-size: 12px !important;
  }

  td {
    font-size: 8px !important;
  }

  table {
    width: 80%;
  }
}

@media screen and (max-width: 400px) {
  th {
    font-size: 7px !important;
  }

  td {
    font-size: 3px !important;
  }

  table {
    width: 50%;
  }
}

/* .paginationButton {
  border-radius: 100% !important;
  margin-right: 3.5px;
  line-height: 22px !important;
  font-size: 14px !important;
  border: 2px solid #66615b !important;
}
.paginationButton:hover {
  background: #66615b !important;
  color: white !important;
}
.paginationNoSelected {
  background: white !important;
  color: #66615b !important;
}
.icon {
  font-size: 11px;
} */
</style>
